module.exports = __webpack_public_path__ + "bluetooth.png?49f5cd26a55fd06d3b7ed6166df35b95";